<template>
  <p class="formatted-address">
    <span class="formatted-address--street">
      {{street}}
      <br/>
    </span>
    <span v-if="street2" class="formatted-address--street2">
      {{street2}} <br/>
    </span>
    <span class="formatted-address--city">{{city}}, </span>
    <span class="formatted-address--state">{{state}} </span>
    <span class="formatted-address--postalcode">{{postalCode}} </span>
  </p>
</template>

<script>
const PROP_REQUIRED_STRING = {
  type: String,
  required: true,
};
export default {
  props: {
    street: PROP_REQUIRED_STRING,
    street2: {
      type: String,
      default: '',
    },
    city: PROP_REQUIRED_STRING,
    state: PROP_REQUIRED_STRING,
    postalCode: PROP_REQUIRED_STRING,
  },
};
</script>

<style lang="scss" scoped>
.formatted-address {
  margin-bottom: 0;
}
</style>
